import { ReferenceType } from "@/plugins/extensions/ReferenceType"

export const getHrefByType = (
  type: ReferenceType,
  info: Record<string, unknown>,
  accountName: string,
  projectName: string
) => {
  let link
  switch (type) {
    case ReferenceType.USER:
      link = `mailto:${String(info.email ?? "").toLowerCase()}`
      break
    case ReferenceType.PREVIOUS_TASK_OWNER:
      link = `mailto:${String(info.email ?? "").toLowerCase()}`
      break
    case ReferenceType.PROJECT:
      link = `/${accountName}/projects/${String(info.urlName ?? "")}`
      break
    case ReferenceType.EPIC:
      link = `/${accountName}/${projectName}/epic/${String(info.sequenceNumber ?? "")}`
      break
    case ReferenceType.IDEA:
      link = `/${accountName}/ideas/${projectName}?idea=${String(info.sequenceNumber ?? "")}`
      break
    case ReferenceType.MILESTONE:
      link = `/${accountName}/${projectName}/milestones/${encodeURIComponent(
        String(info.title ?? "") || "a"
      )}`
      break
    case ReferenceType.SPRINT: {
      const team = info.team as { urlName?: string } | undefined
      link = `/${accountName}/${projectName}/${team?.urlName ?? ""}/sprint/${String(info.sequenceNumber ?? "")}`
      break
    }
    case ReferenceType.ITEM:
      link = `/${accountName}/${projectName}-${String(info.sequenceNumber ?? "")}`
      break
    case ReferenceType.TASK:
      link = `/${accountName}/${projectName}-${String(info.parentSequenceNumber ?? "")}?taskId=${String(info.id ?? "")}`
      break
    case ReferenceType.TEAM:
      link = `/${accountName}/team/${String(info.urlName ?? "")}`
      break
    case ReferenceType.FILE_LINK:
      link = ""
      break
  }

  return link
}
